const frJSON = {
  'Templates request has failed': 'La demande de modèles a échoué', // /content/Templates/index.
  'Template Library': 'Bibliothèque de modèles', // /content/Templates/index.
  'Graphics request has failed': 'La demande de graphiques a échoué', // /content/Graphics/index.
  'My graphics': 'Mes graphiques', // /content/Graphics/index.
  'Go to templates list': 'Aller à la liste des modèles', // /content/Graphics/index.
  Copy: 'Copier', // /content/Graphics/_component/Graphic.
  Edit: 'Éditer', // /content/Graphics/_component/Graphic.
  Delete: 'Supprimer', // /content/Graphics/_component/Graphic.
  'View templates list': 'Voir la liste des modèles', // /content/Overview/Hero/index.
  'Preview image': "Aperçu de l'image", // /content/Editor/_component/EditorForm/EditorForm.
  'Guud Creative Studio': 'Guud Creative Studio', // /component/Logo/index.
  'Image editor': "Éditeur d'images", // /component/EditImageModal/index.
  'Use this dialog window to edit a image':
    'Utilisez cette fenêtre de dialogue pour éditer une image', // /component/EditImageModal/index.
  Cancel: 'Annuler', // /component/EditImageModal/index.
  'Save image': "Enregistrer l'image", // /component/EditImageModal/index.
  Version: 'Version', // /component/Logo/index.
  'Edit this image': 'Modifier cette image', // /component/UploadImageField/index.
  'Remove this image': 'Supprimer cette image', // /component/UploadImageField/index.
  'Choose a file or drag it here':
    'Choisissez un fichier ou faites-le glisser ici', // /component/UploadImageField/index.
  'Editor form': "Formulaire de l'éditeur", // /component/Editor/Templates/TemplateResizer.
  'Graphic has been successfully': 'Le graphique a été créé avec succès', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to graphics selection': 'Aller à la sélection de graphiques', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Go to template selection': 'Aller à la sélection de modèles', // /layout/CreativeStudioLayout/EditorHeader/index.
  'Text is too long': 'Le texte est trop long', // /layout/CreativeStudioLayout/EditorHeader/index.
  Download: 'Télécharger', // /layout/CreativeStudioLayout/EditorHeader/index.
  Save: 'Enregistrer', // /layout/CreativeStudioLayout/EditorHeader/index.
  Profile: 'Profil', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Inbox: 'Boîte de réception', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Project: 'Projet', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Sign out': 'Se déconnecter', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Sign in': 'Se connecter', // /layout/CreativeStudioLayout/Header/Userbox/index.
  Workspaces: 'Espaces de travail', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Social Accounts': 'Comptes sociaux', // /layout/CreativeStudioLayout/Header/Userbox/index.
  'Everything you need to create beautiful designs that will engage your audience. Select a template to get started and make your own images for your business and social media.':
    'Tout ce dont vous avez besoin pour créer de beaux designs qui attireront votre audience. Sélectionnez un modèle pour commencer et créez vos propres images pour votre entreprise et vos réseaux sociaux.', // /layout/Content/Overview/Hero/index.
  'Start creating designs that will impress':
    'Commencez à créer des designs qui impressionneront', // /layout/Content/Overview/Hero/index.
  Editor: 'Éditeur', // /layout/Content/Overview/Sidebar/SidebarMenu/items.
  'Create images and videos in seconds':
    'Créez des images et des vidéos en quelques secondes',
  'Start from a template': 'Commencez à partir d’un modèle',
  'Template tags': 'Balises de modèle',
  'Select tags...': 'Sélectionner les balises...',
  Search: 'Chercher',
  'No templates are available. Contact Guud.tv':
    "Il n'y a pas de modèles. Contacter Guud.tv",
  //Graphics view
  'Start creating amazing graphics':
    'Commencez à créer des graphiques étonnants',
  'Search by name': 'Recherche par nom',
  //Settings view
  Settings: 'Paramètres',
  Colors: 'Colores',
  "You don't have colors yet, start creating them":
    "Vous n'avez pas encore de couleurs, commencez à en créer",
  'Create color': 'Créer une couleur',
  'Add color': 'Ajouter une couleur',
  'Color name': 'Nom de la couleur',
  // Account / Payment view
  Trial: 'Procès'
};
export default frJSON;
